module.exports = __webpack_public_path__ + "img/hero_father.73fa54b9.webp";